import ChatSuggestionsThread from "./ChatSuggestionsThread";
export default ChatSuggestionsThread;
